"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTriggerMinHeight = exports.selectTriggerCompactMinHeight = exports.selectCellSpacingConfig = exports.selectCellMobileSpacingConfig = exports.labelTextColor = void 0;
var _sizing = require("./sizing");
const labelTextColor = 'foreground';
exports.labelTextColor = labelTextColor;
const selectTriggerMinHeight = {
  normal: 56,
  dense: 44
};
exports.selectTriggerMinHeight = selectTriggerMinHeight;
const selectTriggerCompactMinHeight = {
  normal: 40,
  dense: 36
};

/** Spacing config for Select Option (web) */
exports.selectTriggerCompactMinHeight = selectTriggerCompactMinHeight;
const selectCellSpacingConfig = {
  outerSpacing: {
    spacingHorizontal: 0,
    spacingVertical: 0
  },
  innerSpacing: {
    offsetHorizontal: 0,
    spacingHorizontal: 2
  }
};

/** Spacing config for Select Option (mobile) */
exports.selectCellSpacingConfig = selectCellSpacingConfig;
const selectCellMobileSpacingConfig = {
  outerSpacing: {
    spacingHorizontal: 0,
    spacingVertical: 0
  },
  innerSpacing: {
    offsetHorizontal: 0,
    spacingHorizontal: _sizing.gutter
  }
};
exports.selectCellMobileSpacingConfig = selectCellMobileSpacingConfig;